import React, { useState } from "react";
import Select from "react-select";
import { InputGroup } from "react-bootstrap";
import { DebounceInput } from "react-debounce-input";

import {
  emptyString,
  advanceSearchfilters,
  MENU_PLACEMENT,
  LIST_SEARCH_DEBOUNCE_MS,
  PERFORMANCE_FILTER_SELECT_MAX_MENU_HEIGHT,
  inboxPageConstants,
} from "../../../constants";
import {
  RadioOption,
  ValueContainerWithSearchIcon,
} from "../../../../../shared";
import { searchSelectStyles } from "./styles";

const { SEARCH_SELECT_MAX_MENU_WIDTH } = inboxPageConstants;

const SearchComponent = ({ queryParams, setQueryParams }) => {
  const [search, setSearch] = useState(emptyString);
  const [selectedFilter, setSelectedFilter] = useState(advanceSearchfilters[0]);

  //Handle simple search
  const handleSimpleSearch = (value) => {
    setSearch(value);
    setQueryParams({
      ...queryParams,
      search: value ? `${selectedFilter.value} = ${value}` : emptyString,
    });
  };

  //Handle selecte search by select
  const handleSearchBySelect = (e) => {
    search && handleSimpleSearch(emptyString);
    setSelectedFilter(e);
  };

  return (
    <div
      className="p-2 border-1 border-bottom inbox-sidebar-header  d-flex align-items-center"
      data-testid="search-div"
    >
      <InputGroup className="border border-1 rounded w-100 inbox-search">
        <InputGroup.Text className="border-0 bg-white text-black p-0 advance-search-dropdwon">
          <Select
            className="w-100"
            name="searchByFilter"
            options={advanceSearchfilters}
            components={{
              IndicatorSeparator: () => null,
              Option: RadioOption,
              ValueContainer: ValueContainerWithSearchIcon,
            }}
            hideSelectedOptions={false}
            closeMenuOnSelect={true}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.value}
            onChange={handleSearchBySelect}
            isSearchable={false}
            maxMenuHeight={PERFORMANCE_FILTER_SELECT_MAX_MENU_HEIGHT}
            maxMenuWidth={SEARCH_SELECT_MAX_MENU_WIDTH}
            menuPlacement={MENU_PLACEMENT.AUTO}
            value={selectedFilter}
            styles={searchSelectStyles}
          />
        </InputGroup.Text>
        <DebounceInput
          debounceTimeout={LIST_SEARCH_DEBOUNCE_MS}
          type="text"
          className="form-control border-0 py-1 px-1"
          placeholder={`Search customer by ${selectedFilter.name.toLowerCase()}`}
          value={search}
          onChange={({ target: { value } }) => handleSimpleSearch(value)}
        />
      </InputGroup>
    </div>
  );
};

export default React.memo(SearchComponent);
